import {isVioOfferOrBundleSelected} from 'modules/accommodation/utils'

import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'

export const useShouldShowHotelCardClickersContent = () => {
  const isHydrated = useIsHydrated()
  const isVioOfferSelected = isHydrated && isVioOfferOrBundleSelected()
  const {isMobile} = useDeviceLayout()

  // this will guard proper exp allocation (only for non vio clickers)
  if (isVioOfferSelected || isMobile) {
    return false
  }

  return true
}
